export default {
  "nav.events": "Sự kiện",
  "nav.gallery": "Thư viện",
  "nav.contact": "Liên hệ",

  "hero.benefit": "3 Phòng • 10 DJ • 1 Vé Full Quyền",
  "hero.getTickets": "Mua vé",
  "hero.soldOut": "Hết vé",

  "land.saveDate": "Lưu ngày lại",
  "land.upcomingA": "Sự kiện",
  "land.upcomingB": "Sắp tới",
  "land.festival": "Lễ hội",
  "land.getTicketsArrow": "Mua vé →",

  "home.watchEyebrow": "Aftermovie & recap",
  "home.watchA": "Xem lại",
  "home.watchB": "Takeover",
  "home.stagesEyebrow": "Một vé, ba thế giới",
  "home.stagesA": "Khám phá",
  "home.stagesB": "3 Sân khấu",
  "stage.seoul.name": "Seoul Floor",
  "stage.seoul.desc": "Powered by SeoulVibes",
  "stage.seoul.floor": "Tầng 7",
  "stage.main.name": "Mainstream Floor",
  "stage.main.desc": "Trải nghiệm DUPLEX cổ điển",
  "stage.main.floor": "Tầng 6",
  "stage.saigon.name": "Saigon Floor",
  "stage.saigon.desc": "Powered by GANGSHII",
  "stage.saigon.floor": "Tầng 5",
  "home.lineupEyebrow": "Lineup",
  "home.whoA": "Ai chơi",
  "home.whoB": "— và khi nào?",
  "home.insideEyebrow": "Từ trên cao",
  "home.insideA": "Bên trong",
  "home.insideB": "Duplex",
  "home.ctaA": "Sẵn sàng cho",
  "home.ctaB": "Takeover?",
  "home.buyTickets": "Mua vé",

  "footer.tagline": "Trải nghiệm lễ hội châu Á lớn nhất Praha. Ba phòng, một vé, những đêm khó quên.",
  "footer.quickLinks": "Liên kết nhanh",
  "footer.faq": "FAQ",
  "footer.terms": "Điều khoản & Điều kiện",
  "footer.privacy": "Chính sách bảo mật",
  "footer.refund": "Chính sách hoàn tiền",
  "footer.followUs": "Theo dõi",
  "footer.rights": "© 2026 ASIA TAKEOVER. Bảo lưu mọi quyền.",
  "footer.doorStaff": "Nhân viên cửa",
  "footer.admin": "Admin",

  "cookies.title": "Cookies",
  "cookies.text": "Chúng tôi dùng cookies cần thiết để vận hành web và xử lý đơn hàng. Với sự đồng ý của bạn, chúng tôi cũng dùng cookies phân tích và marketing (Meta Pixel) để đo hiệu quả quảng cáo. Bạn có thể từ chối cookies tùy chọn và vẫn mua vé bình thường.",
  "cookies.necessary": "Cần thiết (luôn bật)",
  "cookies.analytics": "Phân tích",
  "cookies.marketing": "Marketing / Meta Pixel",
  "cookies.acceptAll": "Chấp nhận tất cả",
  "cookies.customize": "Tùy chỉnh",
  "cookies.save": "Lưu lựa chọn",
  "cookies.reject": "Từ chối tùy chọn",

  "tickets.eyebrow": "Vé",
  "tickets.standard": "Vé Standard",
  "tickets.group": "Nhóm 4 người",
  "tickets.vip": "Vé VIP Table",
  "tickets.nextRelease": "Đợt tiếp theo:",
  "tickets.finalRelease": "Đợt vé online cuối cùng",
  "tickets.soldOut": "Hết vé",
  "tickets.buy": "Mua vé",
  "tickets.buyGroup": "Mua vé nhóm",
  "tickets.groupPerPerson": "4 × Vé Standard · {price} mỗi người",
  "tickets.limitedCapacity": "Số lượng có hạn",
  "tickets.reserve": "Đặt bàn",
  "tickets.vipRequired": "Cần vé VIP Table",
  "tickets.wantTable": "Muốn đặt bàn kèm bottle service? Bạn cần vé VIP Table.",
  "tickets.noRefund": "Vé không hoàn tiền · chỉ hoàn 100% nếu ban tổ chức hủy sự kiện",
  "tickets.swipe": "Vuốt để xem thêm",
  "tickets.priceProgression": "Giá tăng khi mỗi đợt vé bán hết",
  "tickets.loading": "Đang tải vé…",
  "tickets.unavailable": "Hiện không tải được vé",
  "perks.std1": "Vào cả 3 sân khấu",
  "perks.std2": "Khu vực đứng và sàn nhảy",
  "perks.std3": "Vào tất cả quầy bar và rooftop công cộng",
  "perks.no1": "Không vào khu vực bàn VIP",
  "perks.no2": "Không có bàn riêng hay chỗ ngồi đảm bảo",
  "perks.no3": "Không có bottle service",
  "perks.vip1": "Quà bất ngờ ❤️‍🔥🎈 (trị giá 200 Kč)",
  "perks.vip2": "Vào khu VIP tại Seoul Floor (tầng 7) và Saigon Floor (tầng 5).",
  "tickets.gold": "VIP Gold Table",
  "tickets.goldBadge": "Chỉ còn 3 bàn",
  "tickets.goldFee": "Phí bàn 3999 Kč + 899 Kč mỗi khách",
  "perks.gold1": "Bàn gần sân khấu",
  "perks.gold2": "Vào cả 3 sân khấu",
  "perks.gold3": "Vào khu VIP tại Seoul Floor (tầng 7) và Saigon Floor (tầng 5)",
  "perks.gold4": "Vào cửa ưu tiên, toilet VIP và hostess phục vụ",
  "perks.gold5": "1 món quà bất ngờ mỗi khách",
  "perks.gold6": "Bottle service đặt riêng",
  "tickets.buyGold": "Mua Gold Table",
  "checkout.guestsGold": "Số khách (4–14)",
  "checkout.guestsWord": "khách",
  "hero.upgrade": "Nâng cấp lên VIP",
  "upgrade.title": "Nâng cấp lên VIP",
  "upgrade.subtitle": "Đã có vé Standard? Nâng cấp thành VIP Table Ticket với 400 Kč.",
  "upgrade.codeLabel": "Mã vé của bạn",
  "upgrade.codePlaceholder": "ATF-XXXXXX",
  "upgrade.verify": "Kiểm tra vé",
  "upgrade.found": "Đã tìm thấy vé",
  "upgrade.priceLine": "Phí nâng cấp",
  "upgrade.sameQr": "Mã QR của bạn giữ nguyên — sau thanh toán vé sẽ quét như VIP.",
  "upgrade.pay": "Thanh toán nâng cấp",
  "upgrade.processing": "Đang tạo thanh toán…",
  "success.upgradeNote": "Vé của bạn đã là VIP — hãy dùng mã QR ban đầu.",
  "perks.vip3": "Có thể đặt bàn VIP kèm bottle service",
  "perks.vip4": "Hostess phục vụ theo bàn đã đặt",
  "perks.vip5": "Vào ban công VIP tầng 7",
  "perks.vip6": "Vào cửa ưu tiên",
  "perks.vip7": "Toilet VIP",

  "checkout.secure": "Thanh toán an toàn",
  "checkout.fullName": "Họ và tên",
  "checkout.namePlaceholder": "Tên của bạn",
  "checkout.email": "Email",
  "checkout.phone": "Số điện thoại",
  "checkout.quantity": "Số lượng",
  "checkout.ticketOne": "vé",
  "checkout.ticketMany": "vé",
  "checkout.groupNote": "1 nhóm = 4 vé",
  "checkout.discountCode": "Mã giảm giá",
  "checkout.enterCode": "Nhập mã",
  "checkout.apply": "Áp dụng",
  "checkout.codeApplied": "Đã áp dụng mã {code}: −{percent}% (giá gốc {price})",
  "checkout.continueToPayment": "Tiếp tục thanh toán",
  "checkout.secureNote": "Thanh toán thẻ an toàn qua Teya, ngay trên trang này. Vé chỉ được phát hành sau khi thanh toán được xác nhận.",
  "checkout.termsNoteA": "Khi tiếp tục, bạn đồng ý với",
  "checkout.termsNoteB": "Điều khoản & Điều kiện",
  "checkout.termsNoteC": ". Vé không hoàn tiền và có thể chuyển nhượng tự do.",
  "checkout.creating": "Đang tạo đơn hàng…",
  "checkout.securePayment": "Thanh toán an toàn",
  "checkout.groupTickets": "1 nhóm (4 vé)",
  "checkout.teyaNote": "Thanh toán được xử lý bởi Teya. Vé kèm mã QR sẽ được gửi qua email ngay sau khi thanh toán được xác nhận.",
  "checkout.promoApplyFirst": "Hãy bấm Áp dụng để kích hoạt mã giảm giá trước khi thanh toán.",

  "success.confirming": "Đang xác nhận thanh toán…",
  "success.confirmingText": "Chúng tôi đang xác minh thanh toán với cổng thanh toán. Trang tự cập nhật — không cần tải lại.",
  "success.slowNote": "Đang mất nhiều thời gian hơn bình thường — thanh toán vẫn đang được xác nhận. Khi xong, vé sẽ hiện ở đây và chúng tôi cũng gửi qua email. Bạn có thể để trang này mở.",
  "success.confirmed": "Thanh toán thành công",
  "success.youreIn": "Bạn đã có vé!",
  "success.orderLine": "Đơn hàng {order} · {tier} × {qty} · {amount} · Hãy chụp màn hình vé và đưa mã QR ở cửa.",
  "success.loadingTickets": "Đang tải vé…",
  "success.notCompleted": "Thanh toán chưa hoàn tất",
  "success.cancelled": "Thanh toán đã bị hủy.",
  "success.expired": "Phiên thanh toán đã hết hạn.",
  "success.failed": "Thanh toán thất bại.",
  "success.noCharge": "Chưa có vé nào được phát hành và bạn không bị trừ tiền.",
  "success.backToTickets": "Quay lại mua vé",
  "success.refunded": "Đơn hàng đã hoàn tiền",
  "success.refundedText": "Đơn hàng này đã được hoàn tiền {how}.",
  "success.fully": "toàn bộ",
  "success.partially": "một phần",
  "success.notFound": "Không tìm thấy đơn hàng",
  "success.notFoundText": "Chúng tôi không tìm thấy đơn hàng này. Nếu bạn vừa thanh toán, hãy đợi một lát rồi kiểm tra lại.",
  "success.backHome": "← Về trang chủ",

  "reserve.eyebrow": "Vé VIP Table",
  "reserve.titleA": "Đặt",
  "reserve.titleB": "Bàn",
  "reserve.intro": "Cho chúng tôi biết bạn cần gì — chúng tôi sẽ liên hệ lại với các lựa chọn bàn và chi tiết bottle service.",
  "reserve.received": "Đã nhận yêu cầu",
  "reserve.receivedText": "Chúng tôi sẽ liên hệ với bạn sớm để sắp xếp bàn VIP. Hẹn gặp bạn ngày 27.09. tại DUPLEX.",
  "reserve.back": "← Quay lại vé",
  "reserve.fullName": "Họ và tên",
  "reserve.phone": "Số điện thoại",
  "reserve.email": "Email",
  "reserve.guests": "Số khách",
  "reserve.floor": "Tầng ưu tiên",
  "reserve.message": "Tin nhắn (không bắt buộc)",
  "reserve.messagePlaceholder": "Dịp đặc biệt, ngân sách, loại chai yêu thích…",
  "reserve.send": "Gửi yêu cầu",
  "reserve.sending": "Đang gửi…",

  "contact.eyebrow": "Liên hệ",
  "contact.title": "Liên hệ với chúng tôi",
  "contact.email": "Email",
  "contact.instagram": "Instagram",
  "contact.venue": "Địa điểm",
  "contact.note": "Về bàn VIP, hợp tác và báo chí, hãy email cho chúng tôi — chúng tôi sẽ phản hồi trong vòng 48 giờ.",

  "gallery.eyebrow": "Thư viện",
  "gallery.titleA": "Bản",
  "gallery.titleB": "Đồ",
  "gallery.rooms": "KPOP Room • Mainstream Room • Saigon Room",
};
